<tds-header>
  <tds-header-hamburger
    id="demo-hamburger"
    aria-label="Open application drawer"
    aria-haspopup="true"
    aria-expanded="false"
    tdsAriaLabel="Mobile Menu"
    (click)="toggleMobileSideMenu()">
  </tds-header-hamburger>
  <tds-header-title>
    <tds-link>
    <a routerLink="/" style="text-decoration: none;color: var(--tds-header-nav-item-color);">DCP ROLE VALIDATOR</a>
    </tds-link>
  </tds-header-title>


  <!-- <tds-header-item slot="end">
    <a [routerLink]="landingPage"><tds-icon name="home" size="24px"></tds-icon></a>
  </tds-header-item> -->

  <!-- <tds-header-dropdown
    slot="end"
    no-dropdown-icon
    class="demo-hide demo-lg-show">
    <tds-icon
      slot="icon"
      name="profile"
      size="24"
      color="blue-700"
    ></tds-icon>
    <tds-header-dropdown-list size="lg">
      <tds-header-dropdown-list-user
        [header]="profile.name"
        [subheader]="profile.jobTitle"
      >
      </tds-header-dropdown-list-user>
      <tds-header-dropdown-list-item>
        <a>
          <div class="tds-u-pl1 tds-body-02"><strong>{{profile.email}}</strong></div>
        </a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        
          <tds-button variant="ghost" (click)="logout()" text="Log Out" >
            
          </tds-button>
        
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown> -->

  <tds-header-brand-symbol
    slot="end"
    placement="end">
    <a
      aria-label="Scania - red gryphon on blue shield"
      routerLink="/"></a>
  </tds-header-brand-symbol>
</tds-header>
